const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Règles de Confidentialité
          </h1>
          
          <div className="text-center mb-8">
            <h2 className="text-xl font-semibold text-red-600">Nazaï Studio</h2>
          </div>

          <div className="space-y-6 text-gray-700">
            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">1. Introduction</h3>
              <p>
                Chez Nazaï Studio, nous respectons votre vie privée et nous nous engageons à protéger 
                vos données personnelles. Cette politique de confidentialité explique comment nous 
                collectons, utilisons et protégeons vos informations personnelles.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">2. Données Collectées</h3>
              <p>
                Nous collectons les informations suivantes :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Date de naissance (optionnelle)</li>
                <li>Informations de réservation et d'historique des séances</li>
                <li>Données de paiement (traitées de manière sécurisée)</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">3. Utilisation des Données</h3>
              <p>
                Vos données personnelles sont utilisées pour :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Gérer vos réservations et abonnements</li>
                <li>Traiter vos paiements</li>
                <li>Vous envoyer des confirmations et rappels de séances</li>
                <li>Améliorer nos services</li>
                <li>Vous contacter en cas de besoin concernant vos réservations</li>
                <li>Vous envoyer des notifications d'anniversaire (si autorisé)</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">4. Partage des Données</h3>
              <p>
                Nous ne vendons, ne louons ni ne partageons vos données personnelles avec des tiers, 
                sauf dans les cas suivants :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Avec votre consentement explicite</li>
                <li>Pour traiter les paiements (via des prestataires sécurisés)</li>
                <li>Si requis par la loi ou les autorités compétentes</li>
                <li>Pour protéger nos droits légaux</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">5. Sécurité des Données</h3>
              <p>
                Nous mettons en place des mesures de sécurité appropriées pour protéger vos données :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Chiffrement des données sensibles</li>
                <li>Accès restreint aux données personnelles</li>
                <li>Serveurs sécurisés et surveillance continue</li>
                <li>Mises à jour régulières de sécurité</li>
                <li>Formation du personnel sur la protection des données</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">6. Conservation des Données</h3>
              <p>
                Nous conservons vos données personnelles aussi longtemps que nécessaire pour :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Fournir nos services</li>
                <li>Respecter nos obligations légales</li>
                <li>Résoudre les litiges</li>
                <li>Faire respecter nos accords</li>
              </ul>
              <p className="mt-2">
                En général, nous conservons vos données pendant 3 ans après votre dernière activité, 
                sauf obligation légale contraire.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">7. Vos Droits</h3>
              <p>
                Conformément à la réglementation en vigueur, vous disposez des droits suivants :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Droit d'accès à vos données personnelles</li>
                <li>Droit de rectification des données inexactes</li>
                <li>Droit à l'effacement de vos données</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit à la portabilité des données</li>
                <li>Droit d'opposition au traitement</li>
              </ul>
              <p className="mt-2">
                Pour exercer ces droits, contactez-nous à l'adresse : 
                <a 
                  href="mailto:hello@nazaistudio.ma" 
                  className="text-red-600 hover:text-red-700 font-medium ml-1"
                >
                  hello@nazaistudio.ma
                </a>
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">8. Cookies et Technologies Similaires</h3>
              <p>
                Notre application utilise des cookies et technologies similaires pour :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Maintenir votre session de connexion</li>
                <li>Mémoriser vos préférences</li>
                <li>Améliorer les performances de l'application</li>
                <li>Analyser l'utilisation de nos services</li>
              </ul>
              <p className="mt-2">
                Vous pouvez gérer vos préférences de cookies dans les paramètres de votre navigateur.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">9. Notifications Push</h3>
              <p>
                Avec votre consentement, nous pouvons vous envoyer des notifications push pour :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Rappels de séances</li>
                <li>Confirmations de réservation</li>
                <li>Informations importantes sur nos services</li>
                <li>Notifications d'anniversaire</li>
              </ul>
              <p className="mt-2">
                Vous pouvez désactiver ces notifications à tout moment dans les paramètres de votre appareil.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">10. Modifications de cette Politique</h3>
              <p>
                Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. 
                Nous vous informerons de tout changement important par email ou via l'application. 
                Nous vous encourageons à consulter régulièrement cette page.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">11. Contact</h3>
              <p>
                Pour toute question concernant cette politique de confidentialité ou le traitement 
                de vos données personnelles, contactez-nous :
              </p>
              <div className="mt-2">
                <p>
                  Email : 
                  <a 
                    href="mailto:hello@nazaistudio.ma" 
                    className="text-red-600 hover:text-red-700 font-medium ml-1"
                  >
                    hello@nazaistudio.ma
                  </a>
                </p>
                <p>Adresse : Nazaï Studio, Marrakech, Maroc</p>
              </div>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 text-center">
            <p className="text-sm text-gray-500">
              Dernière mise à jour : Janvier 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
